// scale per-char sizes (e.g. a smaller second line) together with the box font size
function setFitFontSize(textObj, size, width) {
  const ratio = size / textObj.fontSize;

  Object.values(textObj.styles || {}).forEach(line => Object.values(line).forEach(style => {
    if (style.fontSize) {
      style.fontSize = Math.round(style.fontSize * ratio * 100) / 100;
    }
  }));

  textObj.set({ fontSize: size, width });
  textObj.initDimensions();
}

export default function shrinkTextToBox(textObj, fontSize, width, height) {
  let size = fontSize;
  setFitFontSize(textObj, size, width);

  while (size > 6 && (textObj.calcTextHeight() > height || textObj.dynamicMinWidth > width)) {
    size--;
    setFitFontSize(textObj, size, width);
  }

  // typing widens the textbox for long words, later fits read the box width from here
  textObj.fitWidth = width;
  textObj.fixedHeight = height;
  textObj.height = Math.max(height, textObj.calcTextHeight());

  return size;
}
